import { render, staticRenderFns } from "./CourseBoardsGroup.vue?vue&type=template&id=1ef95e5d&scoped=true&"
import script from "./CourseBoardsGroup.vue?vue&type=script&lang=ts&"
export * from "./CourseBoardsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBoardsGroup.vue?vue&type=style&index=0&id=1ef95e5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef95e5d",
  null
  
)

export default component.exports